// src/pages/StudentPanel.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ReactComponent as ikona1} from '../../assets/zaplanowane.svg';
import { ReactComponent as ikona2} from '../../assets/zakonczone.svg';
import { ReactComponent as ikona3} from '../../assets/grupa.svg';
import { ReactComponent as ikona4} from '../../assets/dodajkod2.svg';



const api = axios.create({ baseURL: '/api/student' });

export default function StudentPanel() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);
    const [exams, setExams] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('token');
        api.get('/egzaminy/zaplanowane?limit=10', {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(r => setExams(r.data))
            .catch(e => setErr(e?.response?.data?.blad || 'Błąd pobierania'))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div style={{ padding: '0 16px', marginTop:80 }}>
            {/* 4 kafelki – bez liczników */}
            <div data-tour="student-actions" style={{
                display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px,1fr))',
                gap: 16, marginBottom: 24
            }}>
                <Tile title="Nadchodzące egzaminy" onClick={() => navigate('/student/egzaminy/zaplanowane')} iconSvg={ikona1} />
                <Tile title="Zakończone egzaminy" onClick={() => navigate('/student/egzaminy/zakonczone')} iconSvg={ikona2} />
                <Tile title="Moje grupy" onClick={() => navigate('/student/grupy')} iconSvg={ikona3} />
                <Tile title="Dołacz do egzaminu za pomocą kodu" onClick={() => navigate('/student/egzamin/dodaj-kod')} iconSvg={ikona4} />
            </div>

            <h2 data-tour="student-upcoming" style={{ margin: '8px 0 12px' }}>Zaplanowane egzaminy</h2>

            {loading ? (
                <div>Ładowanie…</div>
            ) : err ? (
                <div style={{ color: 'crimson' }}>{err}</div>
            ) : exams.length === 0 ? (
                <EmptyState />
            ) : (
                <div style={{ display: 'grid', gap: 12, maxWidth: 900 }}>
                    {exams.map(ex => (
                        <ExamCard key={ex.term_id} exam={ex} />
                    ))}
                </div>
            )}
        </div>
    );
}

function Tile({ title, onClick, iconSvg: IconSvg, iconSrc }) {
    return (
        <button
            onClick={onClick}
            style={{
                display: 'grid',
                placeItems: 'center',
                gap: 10,
                textAlign: 'center',
                border: '1px solid #e5e7eb',
                borderRadius: 12,
                padding: 16,
                background: 'white',
                cursor: 'pointer',
                boxShadow: '0 1px 2px rgba(0,0,0,.05)',
                transition: 'transform .08s ease, box-shadow .15s ease',
            }}
            onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.98)')}
            onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
            {/* Ikona nad tytułem: preferuj komponent SVG, fallback do <img src> */}
            {IconSvg ? (
                <IconSvg style={{ width: 70, height: 70, opacity: 0.95, fill:'#b02912' }} aria-hidden />
            ) : iconSrc ? (
                <img src={iconSrc} alt="" style={{ width: 80, height: 80, opacity: 0.95 }} />
            ) : null}

            <div style={{ fontSize: 16, fontWeight: 600, marginTop:10 }}>{title}</div>
        </button>
    );
}

function ExamCard({ exam }) {
    const navigate = useNavigate();
    const go = () => navigate(`/student/egzamin/termin/${exam.term_id}/start`);

    return (
        <div
            role="button"
            onClick={go}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && go()}
            tabIndex={0}
            style={{
                border: '1px solid #e5e7eb',
                borderRadius: 12,
                padding: 14,
                background: 'white',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                transition: 'box-shadow .15s ease, transform .02s ease'
            }}
        >
            <div>
                <div style={{ fontWeight: 600 }}>{exam.title}</div>
                <div style={{ color: '#6b7280', fontSize: 14 }}>
                    {exam.group_name} • {new Intl.DateTimeFormat('pl-PL', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(exam.exam_datetime))} • {exam.exam_duration} min
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#111827' }}>
                <span style={{ fontSize: 14, fontWeight: 600 }}>Przejdź</span>
                <span aria-hidden="true" style={{ fontSize: 20, lineHeight: 1 }}>➜</span>
            </div>
        </div>
    );
}

function EmptyState() {
    return (
        <div style={{ border: '1px dashed #d1d5db', borderRadius: 12, padding: 20, color: '#6b7280' }}>
            Brak zaplanowanych egzaminów.
        </div>
    );
}
